import { useState, useEffect } from "react";
import {
  IconButton,
  TableCell,
  TableRow,
  Button,
  Typography,
  Stack,
  Tooltip,
  Modal,
  Box,
  Grid,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Divider,
} from "@pankod/refine-mui";

import axios from "utils/axios";
import { normalizeData } from "utils/utils";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonIcon from "@mui/icons-material/Person";

import InputCell from "./InputCell";
import CustomDatePicker from "components/DatePickerMUI";

import {
  bbStyle,
  bb1Style,
  bb2Style,
  bb3Style,
  btStyle,
  bt1Style,
  bt2Style,
  bt3Style,
} from "./BorderStyles";
import { toast } from "react-toastify";

function ModalModify({ open, handleClose, rateplan, prezziario }) {
  const daysOfWeek = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
  const [daysChecked, setDaysChecked] = useState(Array(7).fill(true));
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [availability, setAvailability] = useState();
  const [minStay, setMinStay] = useState();
  const [minAdvance, setMinAdvance] = useState();
  const [basePrice, setBasePrice] = useState();
  const [breakfastIncluded, setBreakfastIncluded] = useState();
  const [supplBB, setSupplBB] = useState();
  const [supplHB, setSupplHB] = useState();
  const [supplFB, setSupplFB] = useState();
  const [BBid, setBBid] = useState();
  const [HBid, setHBid] = useState();
  const [FBid, setFBid] = useState();

  const handleDateChange = (from, to) => {
    setFromDate(from);
    setToDate(to);
  };

  const handleCheck = (index) => {
    let tmp = [...daysChecked];
    tmp[index] = !tmp[index];
    setDaysChecked(tmp);
  };

  useEffect(() => {
    async function fetchData() {
      var res;
      if (rateplan) {
        res = await axios.get(`/api/rate-plans/${rateplan.ratePlanID}`);
        if (res) {
          res = normalizeData(res.data);
          setAvailability(res.availability);
          setMinStay(res.minStay);
          setMinAdvance(res.minAdvance);
        }
      } else {
        res = await axios.get(
          `/api/prezziarios/${prezziario.prezziarioID}?populate=treatments`
        );
        if (res) {
          res = normalizeData(res.data);
          setBasePrice(res.base_price);
          setBreakfastIncluded(res.breakfast_included);
          if (res.treatments && res.treatments?.length > 0) {
            let tBB = res.treatments.filter((t) => t.name == "BB");
            if (tBB && tBB.length > 0) {
              setSupplBB(tBB[0].pricePerPerson);
              setBBid(tBB[0].id);
            }

            let tHB = res.treatments.filter((t) => t.name == "HB");
            if (tHB && tHB.length > 0) {
              setSupplHB(tHB[0].pricePerPerson);
              setHBid(tHB[0].id);
            }

            let tFB = res.treatments.filter((t) => t.name == "FB");
            if (tFB && tFB.length > 0) {
              setSupplFB(tFB[0].pricePerPerson);
              setFBid(tFB[0].id);
            }
          }
        }
      }
    }
    if (open) fetchData();
  }, [open, prezziario, rateplan]);

  async function handleBulkModify() {
    //shift daysChecked in order to start from Sunday in position 0
    let daysArray = [...daysChecked];
    const lastElement = daysArray.pop();
    daysArray.unshift(lastElement);

    let body = {};
    let path = "/api/tableau-bulk-";
    if (rateplan) {
      body = {
        ratePlanID: rateplan.ratePlanID,
        fromDate: fromDate,
        toDate: toDate,
        daysChecked: daysArray,
        availability,
        minStay,
        minAdvance,
      };
      path += "rateplan";
    } else {
      let treatments = [];
      if (BBid) treatments.push({ id: BBid, pricePerPerson: supplBB });
      if (HBid) treatments.push({ id: HBid, pricePerPerson: supplHB });
      if (FBid) treatments.push({ id: FBid, pricePerPerson: supplFB });
      body = {
        prezziarioID: prezziario.prezziarioID,
        fromDate: fromDate,
        toDate: toDate,
        daysChecked: daysArray,
        basePrice,
        treatments,
      };
      path += "prezziario";
    }

    try {
      let result = await axios.put(path, body);
      toast.success("Modifiche apportate con successo");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      toast.error("Problemi con il salvataggio delle modifiche");
    }
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: 800,
          minWidth: 320,
          background: "#fff",
          border: "unset",
          borderRadius: 4,
          p: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          {rateplan && <Typography>{rateplan?.name}</Typography>}
          {prezziario && (
            <Stack direction="row" spacing={2}>
              <Typography>Prezzario</Typography>
              <Stack direction="row" spacing={0}>
                {Array(prezziario.guests)
                  .fill(0)
                  .map((item, index) => (
                    <PersonIcon key={index} />
                  ))}
              </Stack>
            </Stack>
          )}
        </Typography>
        <Divider sx={{ bgcolor: "grey" }}></Divider>
        <Box mt={2}>
          {/* range date */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} sx={{ height: "100%" }}>
              {/* <TextField
                type="date"
                label="Dal"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              ></TextField> */}
              <CustomDatePicker
                value={fromDate != null ? fromDate : ""}
                onChange={(e) => setFromDate(e)}
                label="Dal"
                disablePast={false}
                fullWidth={true}
                disableDay={(day) => {
                  return day > new Date(toDate);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ height: "100%" }}>
              {/*<TextField
                type="date"
                label="Al"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              ></TextField>*/}
              <CustomDatePicker
                value={toDate != null ? toDate : ""}
                onChange={(e) => setToDate(e)}
                label="Al"
                disablePast={false}
                fullWidth={true}
                disableDay={(day) => {
                  return day < new Date(fromDate);
                }}
              />
            </Grid>
          </Grid>
          {/* Selector giorni specifici */}
          <FormGroup row>
            {daysOfWeek.map((item, index) => (
              <FormControlLabel
                control={
                  <Checkbox
                    size="large"
                    checked={daysChecked[index]}
                    onChange={() => handleCheck(index)}
                  />
                }
                label={item}
                key={index}
              />
            ))}
          </FormGroup>

          {/* TextField campi modificabili */}
          <Box mt={4}>
            {rateplan && (
              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ height: "100%" }}>
                  <TextField
                    type="number"
                    label="Disponibilità"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={availability}
                    onChange={(e) => setAvailability(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sx={{ height: "100%" }}>
                  <TextField
                    type="number"
                    label="Minimo anticipo"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={minAdvance}
                    onChange={(e) => setMinAdvance(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sx={{ height: "100%" }}>
                  <TextField
                    type="number"
                    label="Pernotto minimo"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={minStay}
                    onChange={(e) => setMinStay(e.target.value)}
                  />
                </Grid>
              </Grid>
            )}
            {prezziario && (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={3} sx={{ height: "100%" }}>
                  <TextField
                    type="number"
                    label="Prezzo base"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={basePrice}
                    onChange={(e) => setBasePrice(e.target.value)}
                  ></TextField>
                </Grid>
                {supplBB != undefined && (
                  <Grid item xs={12} md={6} lg={3} sx={{ height: "100%" }}>
                    <TextField
                      type="number"
                      label="Supplemento BB"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={supplBB}
                      disabled={breakfastIncluded}
                      onChange={(e) => setSupplBB(e.target.value)}
                    ></TextField>
                  </Grid>
                )}
                {supplHB != undefined && (
                  <Grid item xs={12} md={6} lg={3} sx={{ height: "100%" }}>
                    <TextField
                      type="number"
                      label="Supplemento HB"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={supplHB}
                      onChange={(e) => setSupplHB(e.target.value)}
                    ></TextField>
                  </Grid>
                )}
                {supplFB != undefined && (
                  <Grid item xs={12} md={6} lg={3} sx={{ height: "100%" }}>
                    <TextField
                      type="number"
                      label="Supplemento FB"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={supplFB}
                      onChange={(e) => setSupplFB(e.target.value)}
                    ></TextField>
                  </Grid>
                )}
              </Grid>
            )}
          </Box>
          <Box mt={4} textAlign="right">
            <Button
              variant="contained"
              onClick={handleBulkModify}
              disabled={toDate < fromDate || !fromDate || !toDate}
            >
              Conferma
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

function ModifyButton({
  openModal,
  handleOpen,
  handleClose,
  rateplan,
  prezziario,
}) {
  return (
    <>
      <Button
        size="small"
        variant="contained"
        disableElevation
        sx={{ m: 1, bgcolor: "grey.3", color: "white", fontSize: "10px" }}
        onClick={() => {
          handleOpen();
        }}
      >
        Modifica
      </Button>
      <ModalModify
        open={openModal}
        handleClose={handleClose}
        rateplan={rateplan}
        prezziario={prezziario}
      />
    </>
  );
}

function PrezziarioRow({
  prezziario,
  accommodationID,
  ratePlanID,
  firstDay,
  last,
  lastPlan,
  loading,
}) {
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      {/* riga prezzo base */}
      <TableRow sx={{ "& td": { borderBottom: "unset" } }}>
        <TableCell
          style={{
            textAlign: "left",
            verticalAlign: "bottom",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <ModifyButton
              openModal={openModal}
              handleOpen={handleOpen}
              handleClose={handleClose}
              prezziario={prezziario}
            />
            <Stack direction="row" spacing={0}>
              {Array(prezziario.guests)
                .fill(0)
                .map((item, index) => (
                  <PersonIcon key={index} />
                ))}
            </Stack>
          </Stack>
        </TableCell>
        <TableCell align="right">
          <Typography variant="caption">Prezzo base</Typography>
        </TableCell>
        <TableCell />
        {prezziario.base_price.map((item, index) => {
          var date = new Date(firstDay);
          date.setDate(firstDay.getDate() + index);
          return (
            <TableCell key={index} align="center">
              <InputCell
                value={loading ? null : item}
                accommodationID={accommodationID}
                ratePlanID={ratePlanID}
                prezziarioID={prezziario.prezziarioID}
                resource="prezziario"
                field="base_price"
                fromDate={date}
                toDate={date}
              />
            </TableCell>
          );
        })}
      </TableRow>
      {/* Le righe suppl. devono comparire solo se i trattamenti sono stati aggiunti su quel piano tariff. 
        
        riga supplemento BB. 
        NB: if breakfastIsIncluded la casella di testo non è editabile */}
      {prezziario.BB?.length > 0 && (
        <TableRow
          sx={
            prezziario.HB?.length > 0 || prezziario.FB?.length > 0
              ? { "& td": { borderBottom: "unset" } }
              : last
              ? lastPlan
                ? { "& td": bb3Style }
                : { "& td": bb2Style }
              : { "& td": bb1Style }
          }
        >
          <TableCell />
          <TableCell align="right">
            <Typography variant="caption">Suppl. BB</Typography>
          </TableCell>
          <TableCell />
          {prezziario.BB.map((item, index) => {
            var date = new Date(firstDay);
            date.setDate(firstDay.getDate() + index);
            return (
              <TableCell key={index} align="center">
                <InputCell
                  value={loading ? null : item.value}
                  disabled={item.disabled}
                  accommodationID={accommodationID}
                  ratePlanID={ratePlanID}
                  prezziarioID={prezziario.prezziarioID}
                  treatmentID={item.treatmentID}
                  resource="treatment"
                  field="pricePerPerson"
                  fromDate={date}
                  toDate={date}
                />
              </TableCell>
            );
          })}
        </TableRow>
      )}

      {/* riga supplemento HB. */}
      {prezziario.HB?.length > 0 && (
        <TableRow
          sx={
            prezziario.FB?.length > 0
              ? { "& td": { borderBottom: "unset" } }
              : last
              ? lastPlan
                ? { "& td": bb3Style }
                : { "& td": bb2Style }
              : { "& td": bb1Style }
          }
        >
          <TableCell />
          <TableCell align="right">
            <Typography variant="caption">Suppl. HB</Typography>
          </TableCell>
          <TableCell />
          {prezziario.HB.map((item, index) => {
            var date = new Date(firstDay);
            date.setDate(firstDay.getDate() + index);
            return (
              <TableCell key={index} align="center">
                <InputCell
                  value={loading ? null : item.value}
                  accommodationID={accommodationID}
                  ratePlanID={ratePlanID}
                  prezziarioID={prezziario.prezziarioID}
                  treatmentID={item.treatmentID}
                  resource="treatment"
                  field="pricePerPerson"
                  fromDate={date}
                  toDate={date}
                />
              </TableCell>
            );
          })}
        </TableRow>
      )}

      {/* riga supplemento FB. */}
      {prezziario.FB?.length > 0 && (
        <TableRow
          sx={
            last
              ? lastPlan
                ? { "& td": bb3Style }
                : { "& td": bb2Style }
              : { "& td": bb1Style }
          }
        >
          <TableCell />
          <TableCell align="right">
            <Typography variant="caption">Suppl. FB</Typography>
          </TableCell>
          <TableCell />
          {prezziario.FB.map((item, index) => {
            var date = new Date(firstDay);
            date.setDate(firstDay.getDate() + index);
            return (
              <TableCell key={index} align="center">
                <InputCell
                  value={loading ? null : item.value}
                  accommodationID={accommodationID}
                  ratePlanID={ratePlanID}
                  prezziarioID={prezziario.prezziarioID}
                  treatmentID={item.treatmentID}
                  resource="treatment"
                  field="pricePerPerson"
                  fromDate={date}
                  toDate={date}
                />
              </TableCell>
            );
          })}
        </TableRow>
      )}
    </>
  );
}

function RatePlanRow({ rateplan, firstDay, accommodationID, last, loading }) {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      {/* riga con disponibilità */}
      <TableRow sx={{ "& td": { borderBottom: "unset" } }}>
        <TableCell style={{ paddingLeft: 12 }}>{rateplan.name}</TableCell>
        <TableCell>
          <Typography variant="caption">Disponibilità</Typography>
        </TableCell>
        <TableCell />
        {rateplan.still_available_in_that_date.map((item, index) => {
          var date = new Date(firstDay);
          date.setDate(firstDay.getDate() + index);
          return (
            <TableCell key={index} align="center">
              <Tooltip
                title={`${item}/${rateplan.availability[index]}. ${
                  rateplan.availability[index] - item
                } prenotazioni`}
                arrow
                PopperProps={{
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -14],
                      },
                    },
                  ],
                }}
              >
                <div>
                  <InputCell
                    value={loading ? null : item}
                    bookings={rateplan.availability[index] - item}
                    accommodationID={accommodationID}
                    ratePlanID={rateplan.ratePlanID}
                    field="availability"
                    resource="rate-plan"
                    fromDate={date}
                    toDate={date}
                  />
                </div>
              </Tooltip>
            </TableCell>
          );
        })}
      </TableRow>

      {/* riga con minAdvance */}
      <TableRow sx={{ "& td": { borderBottom: "unset" } }}>
        <TableCell align="left" />

        <TableCell>
          <Typography variant="caption">Min. Adv.</Typography>
        </TableCell>
        <TableCell />
        {rateplan.minAdvance.map((item, index) => {
          var date = new Date(firstDay);
          date.setDate(firstDay.getDate() + index);
          return (
            <TableCell key={index} align="center">
              <InputCell
                value={loading ? null : item}
                accommodationID={accommodationID}
                ratePlanID={rateplan.ratePlanID}
                field="minAdvance"
                resource="rate-plan"
                fromDate={date}
                toDate={date}
              />
            </TableCell>
          );
        })}
      </TableRow>

      {/* riga con minStay */}
      <TableRow
        sx={last && !open ? { "& td": bb3Style } : { "& td": bb2Style }}
      >
        <TableCell align="left">
          <ModifyButton
            openModal={openModal}
            handleOpen={handleOpen}
            handleClose={handleClose}
            rateplan={rateplan}
          />
        </TableCell>
        <TableCell>
          <Typography variant="caption">Min. Stay</Typography>
        </TableCell>
        <TableCell>
          <IconButton
            aria-label="expand plan"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {rateplan.minStay.map((item, index) => {
          var date = new Date(firstDay);
          date.setDate(firstDay.getDate() + index);
          return (
            <TableCell key={index} align="center">
              <InputCell
                value={loading ? null : item}
                accommodationID={accommodationID}
                ratePlanID={rateplan.ratePlanID}
                field="minStay"
                resource="rate-plan"
                fromDate={date}
                toDate={date}
              />
            </TableCell>
          );
        })}
      </TableRow>
      {/*prezziari, se aperti*/}
      {open &&
        rateplan.prezziari.map((prezziario, index) => (
          <PrezziarioRow
            key={index}
            accommodationID={accommodationID}
            ratePlanID={rateplan.ratePlanID}
            prezziario={prezziario}
            firstDay={firstDay}
            last={index == rateplan.prezziari.length - 1}
            lastPlan={last}
            loading={loading}
          />
        ))}
    </>
  );
}

export default function AccommodationRow({ row, firstDay, loading }) {
  const [open, setOpen] = useState(false);

  //& > *: This selector targets all direct children (> *) of the current element (&).
  //In this case, it selects all the immediate children of the TableRow.
  //"& > *": { borderBottom: "unset" },

  return (
    <>
      <TableRow sx={open ? { "& td": bb2Style } : { "& td": bb3Style }}>
        <TableCell style={{ minWidth: 120 }}>
          <Typography variant="subtitle1">{row.accommodationName}</Typography>
        </TableCell>
        <TableCell />
        <TableCell>
          <IconButton
            aria-label="expand accommodation"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {row.remainingQuantity.map((item, index) => {
          var date = new Date(firstDay);
          date.setDate(firstDay.getDate() + index);
          return (
            <TableCell key={index} align="center">
              <InputCell
                value={loading ? null : item}
                accommodationID={row.accommodationID}
                field="quantity"
                resource="accommodation"
                fromDate={date}
                toDate={date}
                disabled
              />
            </TableCell>
          );
        })}
      </TableRow>

      {open &&
        row.rateplans.map((rateplan, index) => (
          <RatePlanRow
            key={index}
            rateplan={rateplan}
            firstDay={firstDay}
            accommodationID={row.accommodationID}
            last={index == row.rateplans.length - 1}
            loading={loading}
          />
        ))}
    </>
  );
}
